import { useEffect, useCallback, useRef, useState } from "react";
import logo from "../../../assets/images/logo-sm.png";
import logoDark from "../../../assets/images/logo-dark.png";
import logoHas from "../../../assets/images/LOGO HAS.png";
import logoCms from "../../../assets/images/LOGO CMS.png";
import logoWAP from "../../../assets/images/LOGO WAP.png";
import logoNSP from "../../../assets/images/LOGO NSP.png";
import handleValidDate from "../../../helpers/utils/handleValidDate";

import { useReactToPrint } from "react-to-print";
import { Spinner } from "reactstrap";

export const ButtonPrintReceipt = ({ innerRef, title }) => {
  const [loadingPrint, setLoadingPrint] = useState(false);
  const onBeforeGetContentResolve = useRef(null);

  const reactToPrintContent = useCallback(() => {
    return innerRef.current;
  }, [innerRef]);

  const handleAfterPrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleBeforePrint = useCallback(() => {
    // tslint:disable-line no-console
  }, []);

  const handleOnBeforeGetContent = useCallback(() => {
    setLoadingPrint(true);

    return new Promise((resolve) => {
      onBeforeGetContentResolve.current = resolve;
      setTimeout(() => {
        setLoadingPrint(false);
        resolve();
      }, 2000);
    });
  }, [setLoadingPrint]);

  const handlePrint = useReactToPrint({
    content: reactToPrintContent,
    documentTitle: title,
    onBeforeGetContent: handleOnBeforeGetContent,
    onBeforePrint: handleBeforePrint,
    onAfterPrint: handleAfterPrint,
    removeAfterPrint: true,
  });

  return (
    <button
      type="submit"
      className="btn btn-info"
      onClick={() => {
        handlePrint();
      }}
    >
      CETAK &nbsp;{loadingPrint ? <Spinner size="sm" className="flex-shrink-0 ms-2" role="status"></Spinner> : ""}
    </button>
  );
};

export const PrintDocReceipt = ({ innerRef, code, amount, name, note, date, branchCode, companyName, companyValue }) => {
  function currencyFormat(num) {
    return parseFloat(num || 0).toLocaleString(["ban", "id"]);
  }

  function numberToWords(input) {
    const number = Number(input);

    if (isNaN(number)) {
      return "Input harus angka yang valid (contoh: 6500000 atau '6500000')";
    }

    if (number < 0) {
      return "Input harus non-negatif";
    }

    const num = Math.floor(number);

    if (num === 0) {
      return "Nol Rupiah";
    }

    const satuan = ["", "Satu", "Dua", "Tiga", "Empat", "Lima", "Enam", "Tujuh", "Delapan", "Sembilan"];
    const belasan = ["Sepuluh", "Sebelas", "Dua Belas", "Tiga Belas", "Empat Belas", "Lima Belas", "Enam Belas", "Tujuh Belas", "Delapan Belas", "Sembilan Belas"];
    const puluhan = ["", "", "Dua Puluh", "Tiga Puluh", "Empat Puluh", "Lima Puluh", "Enam Puluh", "Tujuh Puluh", "Delapan Puluh", "Sembilan Puluh"];
    const skala = ["", "Ribu", "Juta", "Miliar", "Triliun", "Kuadriliun", "Kuintiliun"];

    function convertLessThanThousand(n) {
      if (n === 0) return "";
      if (n < 10) return satuan[n];
      if (n < 20) return belasan[n - 10];
      if (n < 100) {
        const p = puluhan[Math.floor(n / 10)];
        const s = satuan[n % 10];
        return p + (s ? " " + s : "");
      }
      const ratus = satuan[Math.floor(n / 100)];
      const sisa = n % 100;
      let hasil = ratus + " Ratus";
      if (sisa > 0) hasil += " " + convertLessThanThousand(sisa);
      return hasil;
    }

    let parts = [];
    let temp = num;
    while (temp > 0) {
      parts.push(temp % 1000);
      temp = Math.floor(temp / 1000);
    }

    let result = [];
    for (let i = parts.length - 1; i >= 0; i--) {
      const val = parts[i];
      if (val === 0) continue;

      let chunk = convertLessThanThousand(val);
      if (i > 0) {
        chunk += " " + skala[i];
      }
      if (chunk) result.push(chunk);
    }

    let final = result.join(" ");

    final = final.replace(/^Satu Ribu\b/, "Seribu");

    final = final.replace(/Satu Ratus(?=.*(Juta|Miliar|Triliun|Kuadriliun|Kuintiliun))/g, "Seratus");

    return final + " Rupiah";
  }
  let base64Svg = "";

  const svgElement = document.querySelector("#sl" + code + " svg");

  if (svgElement) {
    const svgString = new XMLSerializer().serializeToString(svgElement);
    const encodedSvgString = encodeURIComponent(svgString);
    base64Svg = `data:image/svg+xml;base64,${btoa(unescape(encodedSvgString))}`;
  } else {
    console.error("SVG not found.");
  }

  return (
    <div className="d-none" style={{ overflow: "scroll" }}>
      <div ref={innerRef} className="bg-white hero-kwitansi" style={{ padding: "40px 60px 40px 60px" }}>
        {(companyValue === 1 || companyValue === 4) &&
          <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
            <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
              <img src={logoHas} alt="" height="80" width="80" />
            </div>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companyName}</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
            </div>
          </div>
        }

        {companyValue === 2 &&
          <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
            <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
              <img src={logoCms} alt="" height="80" width="80" />
            </div>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companyName}</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Perum PESONA KAHURIPAN 1, Ruko Blok L No 1, Cikahuripan, Klapanunggal, Bogor</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
            </div>
          </div>
        }

        {companyValue === 3 &&
          <div style={{ display: "inline-flex", padding: "5px 0", fontSize: "11px", marginBottom: "15px" }}>
            <div style={{ paddingLeft: "10px", paddingRight: "40px", flex: "1", display: "flex", justifyContent: "center", flexDirection: "column", width: "120px" }}>
              <img src={logoWAP} alt="" height="80" width="80" />
            </div>
            <div style={{ textAlign: "left" }}>
              <p style={{ fontWeight: "bold", fontSize: "12px", margin: 0 }}>{companyName}</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Developer, Kontraktor & Trader</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Jl Sudarmanik Desa Jagabaya Kec. Parung Panjang, Bogor</p>
              <p style={{ fontSize: "12px", fontWeight: "normal", margin: 0 }}>Telp: 021-22886425 Email: pesonakahuripan@gmail.com</p>
            </div>
          </div>
        }
        <div style={{ borderTop: "0.5mm solid #000000", borderBottom: "0.5mm solid #000000", paddingTop: "30px", paddingBottom: "30px", display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px", fontSize: "22px", fontWeight: "bold" }}>KWITANSI</div>
        <div>
          <div style={{ display: "flex", justifyContent: "center", alignItems: "center", padding: "5px 0", marginBottom: "10px" }}>{`No : ${branchCode}${code ?? "-"}`}</div>
          <table style={{ marginTop: "10px", width: "100%", borderCollapse: "collapse", tableLayout: "fixed" }}>
            <tbody>
              <tr>
                <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Telah Diterima Dari</td>
                <td style={{ width: "15px" }}>:</td>
                <td style={{ width: "100%" }}>{name ?? "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Banyaknya Uang</td>
                <td style={{ width: "15px" }}>:</td>
                <td style={{ width: "100%" }}>{`${amount !== null ? `${numberToWords(amount)}` : "-"}`}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Untuk Pembayaran</td>
                <td style={{ width: "15px" }}>:</td>
                <td style={{ width: "100%" }}>{code ? `Sales Invoice #${branchCode}${code}` : "-"}</td>
              </tr>
              <tr>
                <td style={{ width: "200px", padding: "2px 4px", fontWeight: "bold", verticalAlign: "top" }}>Keterangan</td>
                <td style={{ width: "15px" }}>:</td>
                <td style={{ width: "100%" }}>{note}</td>
              </tr>
            </tbody>
          </table>
          <div style={{ display: "flex", justifyContent: "space-between" }}>
            <div style={{ flex: "1 1 0%", marginTop: "40px" }}>
              <div style={{ display: "flex", fontSize: "18px", fontWeight: "bold" }}>
                <div style={{ borderTop: "0.5mm solid #000000", borderBottom: "0.5mm solid #000000", padding: "10px 20px" }}>Jumlah</div>
                <div style={{ borderTop: "0.5mm solid #000000", borderBottom: "0.5mm solid #000000", padding: "10px 20px", backgroundColor: "rgb(255, 170, 0)" }}>{`Rp. ${currencyFormat(amount ?? 0)}`}</div>
              </div>
            </div>
            <div style={{ textAlign: "center" }}>
              <p style={{ marginTop: "30px", padding: "0", lineHeight: "0" }}>Bogor, {handleValidDate(date, "D MMM YYYY")}</p>
              {companyName}
              <div style={{ textAlign: "center", position: "relative", padding: "10px 0px" }}>
                <img src={base64Svg} width={90} height={90} alt="" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
